import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LayoutPreset } from "@/components/AppHeader/hooks/useLayoutPresets";
import { TypographyPreset } from "@/components/AppHeader/hooks/useTypographyPresets";

export enum ModalType {
  AI = "AI",
  None = "None",
  Frame = "Frame",
  Text = "Text",
  Image = "Image",
}

export enum CursorType {
  Pointer = "pointer",
  Text = "text",
  Draw = "draw",
  Drive = "drive",
  Pan = "pan",
}

export const iframeSlice = createSlice({
  name: "globalSettings",
  initialState: {
    // Canvas controls
    cursorType: CursorType.Pointer,
    selectedTypographyOption: null,
    previousCursorType: null,

    // If the cursor type was changed from a key down event
    cursorTypeFromKeyDown: false,

    showModal: ModalType.None,
    selectedLayoutOption: null,
  },
  reducers: {
    setCursorType: (state, action) => {
      const { cursorType, fromKeyDown } = action.payload;

      if (cursorType !== state.cursorType) {
        // @ts-expect-error TS2322
        state.previousCursorType = state.cursorType;
      }

      state.cursorType = cursorType;
      state.cursorTypeFromKeyDown = fromKeyDown;
    },
    setModal: (state, action: PayloadAction<ModalType>) => {
      state.showModal = action.payload;
    },
    revertCursorType: (state) => {
      const currentType = state.cursorType;
      // @ts-expect-error TS2322
      state.cursorType = state.previousCursorType;
      // @ts-expect-error TS2322
      state.previousCursorType = currentType;
      state.cursorTypeFromKeyDown = false;
    },
    setSelectedTypographyOption: (
      state,
      action: PayloadAction<TypographyPreset>
    ) => {
      // @ts-expect-error TS2322
      state.selectedTypographyOption = action.payload;
    },
    setSelectedLayoutOption: (state, action: PayloadAction<LayoutPreset>) => {
      // @ts-expect-error TS2322
      state.selectedLayoutOption = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setCursorType,
  setSelectedTypographyOption,
  revertCursorType,
  setModal,
  setSelectedLayoutOption,
} = iframeSlice.actions;

export default iframeSlice.reducer;
